import { proxy } from 'valtio';
import { AlertMessage } from '@models/error.model';

interface IGenericStore {
	alerts: AlertMessage[];
}

class GenericStore {
  // Initial state setup
  state = proxy<IGenericStore>({
    alerts:[]
  });

}

export const genericState = proxy(new GenericStore());